<div class="main-content manageClients">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4" style="margin-bottom: 5px;height: 0px;">

                    <div class="breadcrumbs" style="top: -25px;">
                        <span class="active">Manage Clients <i [popover]="esr" class="fas fa-question-circle pointer"></i></span>
                    </div>

                    <!--<h1 class="h3 mb-0 text-gray-800">Manage Clients <i [popover]="esr" class="fas fa-question-circle pointer"></i></h1>-->
                    <popover-content #esr
                                     title="Manage Clients"
                                     placement="right"
                                     [animation]="true"
                                     [closeOnClickOutside]="true">
                        <p>Delete or add clients here. Use the action tab to the right to purchase or assign assessments directly from this page</p>
                    </popover-content>

                    <div>
                        <form id="shopifyForm" action="https://community.ipeccoaching.com/sso-eli-shopify/" method="post" enctype="multipart/form-data">
                            <input type="text" name="contact_id" value="" hidden>
                            <input type="email" name="user_email" value="" hidden>
                            <input type="text" name="first_name" value="" hidden>
                            <input type="text" name="last_name" value="" hidden>
                            <!--<input type="submit" value="SSO-Redirect" (click)="ssoToShopify()">-->
                        </form>
                    </div>

                    <div class="quickMenu">
                        <div class="dropdown">
                            <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" data-toggle="dropdown">
                                <span class="button-text"> Actions </span> <i class="fas fa-caret-down" style="vertical-align: unset;"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <!--<li><a (click)="getUserPersonalData()">Purchase assessments</a></li>-->
                                <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase Self assessments</a></li>
                                <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-360-assessment&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase 360 assessments</a></li>
                                <li><a (click)="openAssignModal()">Assign assessments</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="">

                    <div class="desktopTabs" style="position: relative;">
                        <ul class="tab-nav">
                            <li (click)="tabSelect(1)" class="active"><a data-toggle="tab" href="#tab1">Active</a></li>
                            <li (click)="tabSelect(2)"><a data-toggle="tab" href="#tab2">Archived</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content editClientTabs">
                        <div id="tab1" class="tab-pane fade  in active">
                            <div class="">
                                <app-active-clients #activeClients 
                                                    (showTableChange)="onShowActiveClientTableChange($event)"
                                                    (openAssignModal)="onOpenAssignModal($event)">
                                </app-active-clients>
                            </div>
                        </div>

                        <div id="tab2" class="tab-pane fade">
                            <div class="">
                                <app-archived-clients #archivedClients (showTableChange)="onShowArchiveClientTableChange($event)"></app-archived-clients>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assessment-modal #assignAssessment></app-assign-assessment-modal>